<template>
  <div>
    <div
      v-for="item in items"
      :key="item.id"
    >
      <DiaryItem
        :item="item"
        @click="handleClick(item)"
      >
      </DiaryItem>
    </div>
    <DiarySummary
      v-model="diarySummaryDialog"
      :record="currentRecord"
      @prev="handlePrev"
      @next="handleNext"
    ></DiarySummary>
    <v-dialog
      v-model="bodyPartDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="bodyPartDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Body Part Exercised</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container>
          <!-- <vue-apex-charts
            type="line"
            height="400"
            :options="chartOptions"
            :series="series"
          /> -->
          <LineChart
            :data="data"
            :categories="categories"
            legend="Body Part"
          ></LineChart>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script setup>
import VueApexCharts from 'vue-apexcharts'
import { ref, nextTick, onMounted, computed } from 'vue'
import themeConfig from '@themeConfig'
import DiaryItem from './DiaryRecord/DiaryItem.vue'
import LineChart from '@/components/Chart/LineChart.vue'
import { listForChart, fetchList } from '@/api/diaryRecord'
import DiarySummary from './DiaryRecord/DiarySummary.vue'

const diarySummaryDialog = ref(false)

const data = ref([280])
const categories = ref([
])

const bodyPartDialog = ref(false)

const items = ref([
])
const defaultRecord = {
  userRecordID: 0,
  courseDate: '0001-01-01T00:00:00.000Z',
  courseDay: 0,
  workoutTypeID: 0,
  workoutIntensity: 0,
  dailyEvaluation: '',
  hourSelptLastNight: 0,
  moodID: 2,
  appetiteID: 0,
  energyID: 0,
  bodyWeight: 0,
  caloriesExpended: 0,
  trainingItems: [
  ],
  trainingAerobicItems: [],
  id: 0,
}
const currentRecord = ref({
  ...defaultRecord,
})

function handleClick(item) {
  console.log(item)
  currentRecord.value = item

  // bodyPartDialog.value = true
  diarySummaryDialog.value = true
}

const $themeColors = themeConfig.themes.light

onMounted(() => {
  fetchList({
    page: 0,
    limit: 0,
  }).then(res => {
    console.log('res', res)
    const diaryItems = res.data.items
    items.value = []
    for (let index = 0; index < diaryItems.length; index += 1) {
      const diaryItem = diaryItems[index]
      items.value.push(diaryItem)
    }
  })
})

function handlePrev(courseDate) {
  console.log('handlePrev', courseDate)
  if (items.value && items.value.length > 0) {
    const index = items.value.findIndex(record => record.courseDate === courseDate)

    const item = items.value[index]
    console.log('index', index)
    console.log('items', items)
    if (index >= 0 && index < items.value.length - 1) {
      const prevItem = items.value[index + 1]
      currentRecord.value = prevItem
      console.log('prev item', index, prevItem)
    }
  }
}

function handleNext(courseDate) {
  console.log('handleNext', courseDate)
  if (items.value && items.value.length > 0) {
    const index = items.value.findIndex(record => record.courseDate === courseDate)
    const item = items.value[index]
    if (index > 0) {
      const nextItem = items.value[index - 1]
      console.log('prev item', index, nextItem)
      currentRecord.value = nextItem
    }
  }
}

</script>
<style scoped>
</style>
